import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';

const Sections = [
  {
    name: 'seccion 01',
    description: 'habitos del conductor',
    progress: '80%'
  },
  {
    name: 'seccion 02',
    description: 'habitos del conductor',
    progress: '20%'
  }
]
@Component({
  selector: 'app-user-home',
  templateUrl: './user-home.component.html',
  styleUrls: ['./user-home.component.scss']
})
export class UserHomeComponent implements OnInit {
  panelOpenState = false;
  sections=Sections;

  tokeninfo = <any>JSON.parse(atob(sessionStorage.getItem('token')!.split('.')[1]))
  role=this.tokeninfo.role

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher,
    private router:Router) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
  }




  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  newUser(){
    this.router.navigate(['homeuser/candidates'])
  }

  logout(){   
    sessionStorage.clear()
    this.router.navigate(['/login'])  
  }

  createExam(){
    this.router.navigate(['homeuser/newtest'])  
  }


}
